/* src/modules/interviews/components/ConfirmationPopup/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  Divider,
  Modal,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from './styles';
import { loadTexts } from '../../../config/texts';

const TEXT_KEY = 'components';

class ConfirmationPopup extends React.Component {
  renderTitleBar() {
    const { title } = this.props;
    return (
      <AppBar position="static">
        <Toolbar>
          <Typography variant="title" color="inherit">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
    );
  }

  renderContent(classes) {
    const { subtitle, content } = this.props;
    return (
      <div className={classes.content}>
        <Typography className={classes.subtitle}>
          {subtitle}
        </Typography>
        {content()}
      </div>
    );
  }

  renderButtons(classes) {
    const { affirmativeButtonText, onClose, onSubmit, noCancel, locale } = this.props;
    const texts = loadTexts(TEXT_KEY, locale);

    return (
      <div className={classes.buttonContainer}>
        {!noCancel && (
          <Button color="secondary" onClick={onClose}>
            {texts.button_text.cancel}
          </Button>
        )}
        <Button color="primary" onClick={onSubmit}>
          {affirmativeButtonText}
        </Button>
      </div>
    );
  }

  render() {
    const { classes, onClose, open } = this.props;

    return (
      <Modal
        aria-labelledby="Confirmation"
        aria-describedby="confirmation box"
        open={open}
        onClose={onClose}
      >
        <Card className={classes.card}>
          {this.renderTitleBar(classes)}
          {this.renderContent(classes)}
          <Divider />
          {this.renderButtons(classes)}
        </Card>
      </Modal>
    );
  }
}

ConfirmationPopup.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  affirmativeButtonText: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  content: PropTypes.func,
  noCancel: PropTypes.bool,
};

ConfirmationPopup.defaultProps = {
  content: () => null,
  noCancel: false,
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'ConfirmationPopup' }),
  connect(mapStateToProps, {})
)(ConfirmationPopup);



// WEBPACK FOOTER //
// ./src/app/components/ConfirmationPopup/index.js